<template>
  <div class="nav-bar-nav navbar-right navbar-search">
    <div class="main-menu-search" role="search">
      <button
        id="buttonid"
        v-tag:useractionevent="{
          event: 'uaevent',
          ecommerce: 'undefined',
          eventCategory: 'main menu navigation',
          eventAction: 'select::header',
          eventLabel: 'search',
        }"
        class="main-menu-search__trigger"
        :class="{ 'is-active': searchShow }"
        :aria-expanded="searchShow ? 'true' : 'false'"
        @click="searchToggle()"
      >
        <span class="search__shapes">
          <span class="line" /><span class="line" /><span class="circle" />
          <span class="is-sr-only">Search</span>
        </span>
        <span id="searchtext" :style="[searchShow ? { opacity: '0' } : { opacity: '1' }]">{{
          menuTitle
        }}</span>
      </button>
      <transition name="main-menu-search">
        <section
          v-show="searchShow"
          class="main-menu-search__wrapper"
          :class="{ 'active showSearch': searchShow }"
        >
          <div class="search-flex">
            <div class="input-group">
              <div class="input-group-addon">
                <svg class="svg-icon" viewBox="0 0 20 20" @click="searchSubmit()">
                  <path
                    fill="none"
                    d="M12.323,2.398c-0.741-0.312-1.523-0.472-2.319-0.472c-2.394,0-4.544,1.423-5.476,3.625C3.907,7.013,3.896,8.629,4.49,10.102c0.528,1.304,1.494,2.333,2.72,2.99L5.467,17.33c-0.113,0.273,0.018,0.59,0.292,0.703c0.068,0.027,0.137,0.041,0.206,0.041c0.211,0,0.412-0.127,0.498-0.334l1.74-4.23c0.583,0.186,1.18,0.309,1.795,0.309c2.394,0,4.544-1.424,5.478-3.629C16.755,7.173,15.342,3.68,12.323,2.398z M14.488,9.77c-0.769,1.807-2.529,2.975-4.49,2.975c-0.651,0-1.291-0.131-1.897-0.387c-0.002-0.004-0.002-0.004-0.002-0.004c-0.003,0-0.003,0-0.003,0s0,0,0,0c-1.195-0.508-2.121-1.452-2.607-2.656c-0.489-1.205-0.477-2.53,0.03-3.727c0.764-1.805,2.525-2.969,4.487-2.969c0.651,0,1.292,0.129,1.898,0.386C14.374,4.438,15.533,7.3,14.488,9.77z"
                  ></path>
                </svg>
              </div>
              <input
                id="search-field"
                ref="searchInput"
                v-model="searchValue"
                :placeholder="placeholderSearch"
                aria-describedby="search-field-help"
                autocomplete="off"
                class="main-menu-search__input"
                type="search"
                :maxlength="searchValueMaxLength"
                @keyup.enter="searchSubmit()"
              />
              <div v-show="showLoader" class="input-group-addon loader-css">
                <span class="sr-only">Loading</span>
              </div>
            </div>
          </div>
        </section>
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  name: 'search-header',
  props: {
    articleBaseUrl: {
      type: String,
      required: true,
    },
    placeholderSearch: {
      type: String,
      required: true,
    },
    noProducts: {
      type: String,
      required: true,
    },
    menuTitle: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      searchShow: false,
      active: false,
      searchValue: '',
      searchValueMaxLength: 200,
      showLoader: false,
    };
  },
  created() {
    localStorage.noProducts = this.noProducts;
  },
  methods: {
    searchSubmit() {
      const regexVal = this.searchValue.replace(/['"@#]+/g, '');
      this.searchValue = regexVal;

      this.showLoader = true;
      window.location.href = `${this.articleBaseUrl}?query=${this.searchValue}`;
      localStorage.searchValue = this.searchValue;
      localStorage.noProducts = this.noProducts;
    },
    searchToggle() {
      this.searchShow = !this.searchShow;
      if (this.searchShow) {
        const menuItemActive = document.querySelector('.sidebar-nav li.active');
        if (menuItemActive) {
          menuItemActive.classList -= '.active';
          document.querySelector('.main-menu-search section').style.visibility = 'visible';
        }
      }
    },
  },
};
</script>
<style lang="scss">
.svg-icon path,
.svg-icon polygon,
.svg-icon rect {
  fill: black;
}

.svg-icon circle {
  stroke: black;
  stroke-width: 1;
}

#buttonid {
  font-size: 1em;
  margin: 0;
  padding: 0;
  border: none;
  background: none;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;

  li {
    margin: 0;
    padding: 0;
  }
}

.showSearch {
  visibility: initial !important;
}
</style>
